import { axios } from '@/utils/request';
const api = {
  productionLine: 'service/cost_time/info/production_line',
  outsourcer: 'service/cost_time/info/outsourcer',
  operator: 'service/cost_time/info/operator',
  passRate: 'service/cost_time/overview/pass_rate',
  operatorPassDistribution: 'service/cost_time/overview/operator_pass_distribution',
  operatorRank: 'service/cost_time/overview/operator_rank',
  passCount: 'service/cost_time/overview/outsourcer_production_line_pass_count',
  operator_rank_export: 'service/cost_time/overview/operator_rank_export',
  distribution: 'service/cost_time/overview/operator_no_pass_distribution',
  pro_out_rate: 'service/cost_time/overview/outsourcer_production_line_pass_rate',
  pass_rate_detail: 'service/cost_time/overview/pass_rate_detail',
  pass_rate_detail_export: 'service/cost_time/overview/pass_rate_detail_export',
  unusual_rate_distribution: 'service/cost_time/overview/unusual_rate_distribution',
  statistic: 'service/cost_time/detail/statistic',
  overviewTable: 'service/cost_time/detail/overview',
  overviewExport: 'service/cost_time/detail/overview_export',
  detailsTable: 'service/cost_time/detail/details',
  detailsExport: 'service/cost_time/detail/details_export',
  fill_in_list: 'service/cost_time/check/fill_in_list',
  fill_in_save: 'service/cost_time/check/fill_in_save',
  check_list: 'service/cost_time/check/check_list',
  check_save: 'service/cost_time/check/check_save',
  outsourcer_check: 'service/cost_time/check/outsourcer',
  productionLine_check: 'service/cost_time/check/production_line',
};

function setDateToNum(params) {
  // eslint-disable-next-line camelcase
  let { start_time, end_time } = params;
  // eslint-disable-next-line camelcase
  if (start_time && start_time instanceof Date) {
    // eslint-disable-next-line camelcase
    start_time = start_time.getTime();
  }
  // eslint-disable-next-line camelcase
  if (end_time && end_time instanceof Date) {
    // eslint-disable-next-line camelcase
    end_time = end_time.getTime();
  }

  return {
    ...params,
    start_time,
    end_time,
  };
}
/**
 *人员画像概览——筛选条件——产线
 * @param {*} params
 */
export function getProductionLine(params) {
  return axios({
    url: api.productionLine,
    method: 'get',
    params,
  });
}

export function getOutsourcer(params) {
  return axios({
    url: api.outsourcer,
    method: 'get',
    params,
  });
}
export function getOperator(params) {
  return axios({
    url: api.operator,
    method: 'get',
    params: setDateToNum(params),
  });
}
export function getPassRate(params) {
  return axios({
    url: api.passRate,
    method: 'get',
    params: setDateToNum(params),
  });
}
export function getOperatorPassDistribution(params) {
  return axios({
    url: api.operatorPassDistribution,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getOperatorRank(params) {
  return axios({
    url: api.operatorRank,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getPassCount(params) {
  return axios({
    url: api.passCount,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getTopRank(params) {
  return axios({
    url: api.operator_rank_export,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getDistribution(params) {
  return axios({
    url: api.distribution,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getOutAndProLineRate(params) {
  return axios({
    url: api.pro_out_rate,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getPassRateDetail(params) {
  return axios({
    url: api.pass_rate_detail,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function passRateDetaiExport(params) {
  return axios({
    url: api.pass_rate_detail_export,
    method: 'get',
    params: setDateToNum(params),
  });
}

export function getUnusualRateDistribution(params) {
  return axios({
    url: api.unusual_rate_distribution,
    method: 'get',
    params: setDateToNum(params),
  });
}

function setParams(params) {
  const tmp = setDateToNum(params);
  // eslint-disable-next-line no-restricted-syntax
  for (const key in tmp) {
    if (tmp[key] === 0) {
      delete tmp[key];
    }
  }
  return tmp;
}

export function getStatistic(params) {
  return axios({
    url: api.statistic,
    method: 'get',
    params: setParams(params),
  });
}

export function getOverviewTable(params) {
  return axios({
    url: api.overviewTable,
    method: 'get',
    params: setParams(params),
  });
}
export function getOverviewExport(params) {
  return axios({
    url: api.overviewExport,
    method: 'get',
    params: setParams(params),
  });
}

export function getDetailworkTable(params) {
  return axios({
    url: api.detailsTable,
    method: 'get',
    params: setParams(params),
  });
}

export function getDetailsExport(params) {
  return axios({
    url: api.detailsExport,
    method: 'get',
    params: setParams(params),
  });
}

export function getFillInList(params) {
  return axios({
    url: api.fill_in_list,
    method: 'get',
    params,
  });
}

export function setCheckList(params) {
  return axios({
    url: api.fill_in_save,
    method: 'post',
    data: params,
  });
}

export function getCheckList(params) {
  return axios({
    url: api.check_list,
    method: 'get',
    params,
  });
}

export function postCheckSave(params) {
  return axios({
    url: api.check_save,
    method: 'post',
    data: params,
  });
}

export function outsourcerApi(params = {}) {
  return axios({
    url: api.outsourcer_check,
    method: 'get',
    data: params,
  });
}

export function productionLineApi(params = {}) {
  return axios({
    url: api.productionLine_check,
    method: 'get',
    data: params,
  });
}
